import { Route, Routes } from 'react-router-dom-v5-compat';
import { ReportingActivate } from 'src/components/organisms/Reporting/ReportingActivate';
import { ReportingAddEvidence } from 'src/components/organisms/Reporting/ReportingAddEvidence/ReportingAddEvidence';
import { ReportingChangePassword } from 'src/components/organisms/Reporting/ReportingChangePassword/ReportingChangePassword';
import { ReportingConnect } from 'src/components/organisms/Reporting/ReportingConnect';
import { ReportingSendResetPasswordEmail } from 'src/components/organisms/Reporting/ReportingForgotPassword/ReportingSendResetPasswordEmail/ReportingSendResetPasswordEmail';
import { ReportingUpdatePassword } from 'src/components/organisms/Reporting/ReportingForgotPassword/ReportingUpdatePassword/ReportingUpdatePassword';
import ReportingLogin from 'src/components/organisms/Reporting/ReportingLogin/ReportingLogin';
import { ReportingReport } from 'src/components/organisms/Reporting/ReportingReport/ReportingReport';
import { ReportingReportsList } from 'src/components/organisms/Reporting/ReportingReportsList/ReportingReportsList';
import { ReportingReset } from 'src/components/organisms/Reporting/ReportingReset/ReportingReset';
import { ReportingResetConfirmation } from 'src/components/organisms/Reporting/ReportingResetConfirmation/ReportingResetConfirmation';
import { ReportingResetFail } from 'src/components/organisms/Reporting/ReportingResetFail/ReportingResetFail';
import { ReportingSettings } from 'src/components/organisms/Reporting/ReportingSettings/ReportingSettings';
import PageNotFound from 'src/components/PageNotFound';
import { useTheme } from 'styled-components';
import { AuthenticatedReportingRoute } from './AuthenticatedReportingRoute';
import { ReporterHubPageLayout } from './ReporterHubPageLayout/ReporterHubPageLayout';
import { ReportingRoute } from './ReportingRoute';

const ReportingRouting = () => {
  const theme = useTheme();
  return (
    <Routes>
      <Route element={<ReportingRoute />}>
        <Route path="login" element={<ReportingLogin />} />
        <Route path="activate" element={<ReportingActivate />} />
        <Route path="code/:token" element={<ReportingReset />} />
        <Route path="reset" element={<ReportingSendResetPasswordEmail />} />
        <Route path="reset/:token" element={<ReportingUpdatePassword />} />

        <Route element={<AuthenticatedReportingRoute redirectTo="login" />}>
          <Route
            path="reset-confirmation"
            element={<ReportingResetConfirmation />}
          />
          <Route path="reset-fail" element={<ReportingResetFail />} />
          <Route path="connect" element={<ReportingConnect />} />
          <Route path="change-password" element={<ReportingChangePassword />} />

          <Route element={<ReporterHubPageLayout />}>
            <Route path="reports" element={<ReportingReportsList />} />
            <Route path="reports/:reportId" element={<ReportingReport />} />
            <Route
              path="reports/:reportId/add-evidence"
              element={<ReportingAddEvidence />}
            />
            <Route path="settings" element={<ReportingSettings />} />
          </Route>
        </Route>

        <Route
          path="*"
          element={
            <PageNotFound
              color={
                theme.isVaultVariant
                  ? theme.newPalette.turquoise.T300
                  : theme.atlas.semantic.color.action.primary.default
              }
            />
          }
        />
      </Route>
    </Routes>
  );
};

export default ReportingRouting;
